import React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const ArrowUpIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8002 9.6001L8.00017 4.8001L3.20017 9.6001"
      fill="none"
      stroke="#141E30"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
export default ArrowUpIcon;
